require("utility/icons/new_task_circle.scss");

var NewTaskCircle = function(props) {
	return (
		<div className="newTaskCircle">+</div>
	);
};

NewTaskCircle.propTypes = StrictPropTypes({
});

module.exports = NewTaskCircle;



// WEBPACK FOOTER //
// ./modules/components/utility/icons/NewTaskCircle.js